import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    reportWorkList: (year,month) => {
        return HTTP.get('/work_time/report_work_list?year='+year+'&month='+month, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailReportWork: (date) => {
        return HTTP.get('/work_time/report_work_detail?date='+date, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}